<template>
  <div class="con-list-box">
    <div class="item" v-for="(item,index) in conData" :key="index">
      <div class="topImg"></div>
      <div class="item-content">
        <div class="left">
          <span class="rmb">￥</span>
          <span class="num">{{item.pledgeMoney}}</span>
        </div>
        <div class="right">
          <div class="l-top">
            <h3 class="title">顺丰优惠券</h3>
            <p>
              <span>券号：</span>
              <span>{{item.couponNo}}</span>
            </p>
            <p>
              <span>券码：</span>
              <span>{{item.checkCode}}</span>
            </p>
            <p class="time">
              <span>有效期至</span>
              <span>{{item.invalidDate}}</span>
            </p>
          </div>
          <div class="l-footer">
            <span>{{item.couponDesc}}</span>
          </div>
        </div>
      </div>
      <div class="barCode">

      </div>
    </div>
    <p class="no-more">没有更多了</p>

  </div>
</template>
<script>
import { log } from "util";
import ajax from "@/api/ajax";


export default {

  data() {
    return {
      // 数据源
      conData: []
    };
  },
  created() {
    // 获取数据
    let params = {
      customerTel: sessionStorage.getItem("customerTel"), // 手机号
      couponType: 1, // 实体卷
      status: 1 // 已使用
    };
    let headers = {
      "SMS-Verification-App": "coupon",
      "SMS-Verification-Code": sessionStorage.getItem("yzCode"),
      "SMS-Verification-Mobile": params.customerTel
    };
      ajax
      .getCoupons({ params, headers })
      .then(res => {       
        let { data , status} = res;
        if (data.code === 113) {
          this.$toast("请重新获取验证码");
          this.$router.push({ name: "couponslogin" });
        }
        if (data.code === 0) {
          this.conData = data.result;
        }
      })
      .catch(res => {
        this.$toast("网络异常，稍后重试");
      });
  }

};
</script>
<style lang="scss" scoped>
.con-list-box {
  overflow: hidden;
  color: #ccc;
  .item {
    width: 7.12rem;
    height: 3.1rem;
    box-sizing: border-box;
    border: 1px solid #d2d2d2;
    border-radius: 0.1rem;
    margin: 0 auto;
    padding-right: 0.3rem;
    position: relative;
    margin-top: 0.18rem;
    .topImg {
      width: 7.1rem;
      height: 0.31rem;
      background: url("../../assets/images/coupons/web_pic_red.png") no-repeat
        top;
      background-size: cover;
    }
    .item-content {
      width: 100%;
      height: 2.74rem;
      overflow: hidden;
      display: flex;
      .left {
        width: 2.8rem;
        height: 100%;
        padding-left: 0.6rem;
        padding-top: 0.8rem;
        color: #ccc;
        .rmb {
          font-size: 0.36rem;
        }
        .num {
          font-size: 0.93rem;
        }
      }
      .right {
        flex: 1;
        display: flex;
        flex-direction: column;
        margin-left: -0.2rem;
        .l-top {
          flex: 1;
          .title {
            font-size: 0.3rem;
            line-height: 0.76rem;
            height: 0.76rem;
          }
          p {
            font-size: 0.23rem;
          }
          .time {
            color: #ccc;
            line-height: 2;
          }
        }
        .l-footer {
          height: 0.7rem;
          border-top: 1px solid #d2d2d2;
          font-size: 0.26rem;
          line-height: 0.7rem;
          text-align: right;
          color: #ccc;
        }
      }
    }
    .barCode {
      width: 1.9rem;
      height: 190px;
      position: absolute;
      top: 0.36rem;
      right: 0.22rem;
      background: url("../../assets/images/coupons/web_pic_late.png") no-repeat
        center;
      background-size: cover;
    }
  }
  .no-more {
    font-size: 26px;
    color: #666;
    margin-top: 0.28rem;
    text-align: center;
  }
    .item .topImg {
    background: url("../../assets/images/coupons/web_pic_gray.png") no-repeat
      top;
    background-size: cover;
    margin-top: -2px;
    margin-left: -1px;
  }

  .item .item-content .left {
    color: #ccc;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/coupons/overdueg.vue